module.exports = __webpack_public_path__ + "img/d200807-2.8075f699.jpg";